import { tr } from "date-fns/locale";
import EpgPersistence from "../../../AAF/Nepg/EpgPersistence";
import Utils from "../../../utils/Utils";
import AbstractRequestTask from "../AbstractRequestTask";
import { DOMAIN } from "./const";

class DeleteFavoriteTeamTask extends AbstractRequestTask {
     constructor(teamId, leagueId, acceptLanguage = "es-ES" , version = 'v1') {
        super();
        this.teamId = teamId;
        this.leagueId = leagueId;
        this.acceptLanguage = acceptLanguage;
        this.version = version;
        this.params = super.getParams();
        this.user_token = this.params.user_token;
    }

    getUrl() {
        const http = "https://";
        const domain = DOMAIN;
        const path = `/services/sports/${this.version}/competitions/${this.leagueId}/favorites`;
        const queryParams = Utils.buildQueryParams(this.getQueryParams());
        return `${http}${domain}${path}?${queryParams}`;
    }

    getQueryParams() {
        const params = super.getParams();
        delete params.format
        delete params.api_version
        delete params.user_token
        delete params.HKS
        delete params.device_id
        delete params.device_name
        delete params.device_so
        delete params.user_id

        return {
            ...params,
            timezoneOffset: EpgPersistence.getOffset() / 60
        };
    }

    getParams() {
        return {
            teamId: this.teamId
        };
    }

    getHeaders() {
        return {
            'Authorization': `Bearer ${this.user_token}`,
            'Accept-Language': this.acceptLanguage,
            'Content-Type': 'application/json'
        }
    }

    getEncType() {
        return 'application/json';
    }

    getMethod() {
        return 'DELETE';
    }

    isValid() {
        return true;
    }
}

export default DeleteFavoriteTeamTask;


// WEBPACK FOOTER //
// ./src/requests/tasks/sports/deleteFavoriteteamTask.js